import api from "../../utils/ApiConfig";

export const fetchLoginAttemptsData = async (page = 1, searchTerm = "", filters = {}) => {
  try {
    const response = await api.get(`/bo/login-attempts`, {
      params: {
        page: page,
        per_page: 50,
        email: searchTerm,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching login attempts data:", error);
    throw error;
  }
};

export const fetchLoginAttemptsStats = async (hours = 24) => {
  try {
    const response = await api.get(`/bo/login-attempts/stats`, {
      params: {
        hours: hours,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching login attempts stats:", error);
    throw error;
  }
};

export const detectAttacks = async (minutes = 30, threshold = 5) => {
  try {
    const response = await api.get(`/bo/login-attempts/attacks`, {
      params: {
        minutes: minutes,
        threshold: threshold,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error detecting attacks:", error);
    throw error;
  }
};

export const unlockAccount = async (userId) => {
  try {
    const response = await api.post(`/bo/login-attempts/unlock/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error unlocking account:", error);
    throw error;
  }
};
